import React from 'react';
import stylesheet from '../Graph.module.scss';

const Bar = props => {
    const {flippedProps, color, size} = props;

    return (
        <div
            className={stylesheet.Bar}
            style={{
                backgroundColor: color,
                height: `${size * 100}%`,
            }}
            {...flippedProps}
        />
    );
};

export default Bar;
